import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { KitchenCreateView } from 'src/sections/kitchen/view';

export default function KitchenCreatePage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Create an inventory item</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_KITCHEN_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <KitchenCreateView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
